import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import GoodsGroup from 'view/goodsGroup';

const GoodsGroupManagePage = () => {
	return (
		<PageTemplate>
			<GoodsGroup /> 
		</PageTemplate>
	);
};

export default GoodsGroupManagePage;

 